var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"check-box flex align-center pointer",class:_vm.isActive && (_vm.payload.red ? 'active-checkbox-red' : 'active-checkbox'),on:{"click":_vm.toggle}},[_c('span'),_c('label',{staticClass:"pointer"},[_vm._v(" "+_vm._s(_vm.payload.label)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }